import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

interface Props {
  customerLabel: string;
  pnrs: Array<string>;
  /** The payment reference the agent entered, if any. */
  reference?: string;
  isPending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirms importing PNRs as already paid: the order is confirmed and ticketed straight away. */
export default function ConfirmPaidPnrImportDialog({
  customerLabel,
  pnrs,
  reference,
  isPending,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create this order as already paid?</DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body2">Customer: {customerLabel}</Typography>
          <Typography variant="body2">PNRs: {pnrs.join(', ')}</Typography>
          {reference && <Typography variant="body2">Payment reference: {reference}</Typography>}
          <Typography variant="body2">
            The customer will not be asked to pay. The order is confirmed and ticketing starts immediately, and it
            cannot be cancelled from the import grid afterwards.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onConfirm} disabled={isPending}>
          Create paid order
        </Button>
        <Button variant="text" onClick={onClose}>
          Go back
        </Button>
      </DialogActions>
    </Dialog>
  );
}
